<SearchResult href="{href}">
  {'#' + hashtag.name}
</SearchResult>
<style>
</style>
<script>
  import SearchResult from './SearchResult.html'
  export default {
    components: {
      SearchResult
    },
    computed: {
      href: ({ hashtag }) => '/tags/' + encodeURIComponent(hashtag.name)
    }
  }
</script>
